@import "../../globalStyles/commons";

:host {
  display: contents;
}

img {
  max-height: 100%;
  max-width: 100%;
}
